export default __webpack_public_path__ + "static/media/Status.47648a95.svg";